export const sizeOptions = [
  { id: "1", name: "XS" },
  { id: "2", name: "S" },
  { id: "3", name: "M" },
  { id: "4", name: "L" },
  { id: "5", name: "XL" },
  { id: "6", name: "2XL" },
  { id: "7", name: "3XL" },
  { id: "8", name: "4XL" },
];

export interface MemberPrice {
  id: number;
  distance: string;
  categoryId: number | null;
  price: number;
  jerseySize: string;
}
